import { AppRouteProps } from "@bsm/component";
import { StudentDetailsContainer } from "./container/StudentDetailsContainer";
import { StudentDetailsAboutRoutes } from "./views/about/StudentDetailsAboutRoutes";
import { StudentDetailsParamsRoutes } from "./views/params/StudentDetailsParamsRoutes";
import { StudentParentsRoutes } from "./views/parents/StudentParentsRoutes";
import { StudentProxyRoutes } from "./views/proxy/StudentProxyRoutes";
import { StudentEmmergencytContactRoutes } from "./views/emmergencyContact/StudentEmmergencytContactRoutes";
import { StudentSesignationCollectionIndividualRoutes } from "./views/designationCollectionIndividual/StudentSesignationCollectionIndividualRoutes";
import { SchoolAttendedRoutes } from "./views/schoolAttended/SchoolAttendedRoutes";
import { StudentEducationNeedsAndDisabilitiesRoutes } from "./views/educationNeedsAndDisabilities/StudentEducationNeedsAndDisabilitiesRoutes";
import { StudentHealthAndImmunisationRoutes } from "./views/healthAndImmunisation/StudentHealthAndImmunisationRoutes";
import { StudentHealthAndAllergiesRoutes } from "./views/healthAndAllergies/StudentHealthAndAllergiesRoutes";
import StudentCreationContainer from "views/create/containers/StudentCreationContainer";

export const StudentDetailsRoutes: Array<AppRouteProps> = [
    {
        path: ":id",
        element: <StudentDetailsContainer />,
        children: [
            ...StudentDetailsAboutRoutes,
            ...StudentParentsRoutes,
            ...StudentEmmergencytContactRoutes,
            ...StudentProxyRoutes,
            ...StudentSesignationCollectionIndividualRoutes,
            ...SchoolAttendedRoutes,
            ...StudentEducationNeedsAndDisabilitiesRoutes,
            ...StudentHealthAndImmunisationRoutes,
            ...StudentHealthAndAllergiesRoutes,
            ...StudentDetailsParamsRoutes
        ],
    },
    {
        path: ":id/edit",
        element: <StudentCreationContainer />,
        children: [],
    },
];
